<script setup lang="ts">
/**
 * The sound knob's face: the painted brass speaking horn. Muted, it dims and
 * greys and a thin red bar crosses it; playing, it is full colour.
 */
import GameIcon from '@/ui/kit/GameIcon.vue';

defineProps<{ muted: boolean }>();
</script>

<template>
  <span class="sound-icon" :class="{ muted }" aria-hidden="true">
    <GameIcon name="horn" :size="30" />
  </span>
</template>

<style scoped>
.sound-icon {
  position: relative;
  display: grid;
  place-items: center;
  transition: filter var(--dur) var(--ease);
}

.muted {
  filter: grayscale(0.85) brightness(0.7);
}

.muted::after {
  content: '';
  position: absolute;
  left: 2px;
  right: 2px;
  top: 50%;
  height: 2px;
  border-radius: 2px;
  background: #b4473a;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
  transform: rotate(-35deg);
}
</style>
